import { useUser } from '@clerk/clerk-react'
import { Box } from '@mui/material'
import { useCallback, useState } from 'react'
import { useDebounce } from 'use-debounce'
import CutoffBanner from './sections/cutoff-banner'
import DashboardHeader from './sections/dashboard-header'
import SearchResults, { getSearchType } from './sections/search-results'
import SearchSection from './sections/search-section'
import StatsCards from './sections/stats-cards'

const DEBOUNCE_DELAY = 300
const MIN_SEARCH_LENGTH = 2
const MAX_SEARCH_LENGTH = 50

const HELPER_TEXT = {
  order: 'Searching by order number',
  email: 'Searching by email address',
  phone: 'Searching by phone number',
  postcode: 'Searching by postcode',
  general: 'Searching by email address or name'
} as const

export default function DashboardPage() {
  const { user } = useUser()

  const [inputValue, setInputValue] = useState('')
  const isOverLimit = inputValue.length > MAX_SEARCH_LENGTH
  const [debouncedQuery] = useDebounce(inputValue.trim(), DEBOUNCE_DELAY)
  const isSearching = debouncedQuery.length >= MIN_SEARCH_LENGTH && !isOverLimit

  const searchType = isSearching ? getSearchType(debouncedQuery) : null
  const showResults = searchType !== null
  const helperText = isSearching && !isOverLimit ? HELPER_TEXT[searchType!] : undefined
  const helperVariant = 'info'

  const handleSearchChange = useCallback((value: string) => {
    setInputValue(value)
  }, [])

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <DashboardHeader userName={user?.firstName || user?.fullName} />

      <SearchSection
        searchQuery={inputValue}
        onSearchChange={handleSearchChange}
        isOverLimit={isOverLimit}
        helperText={helperText}
        helperVariant={helperVariant}
      />

      {showResults ? (
        <SearchResults searchQuery={debouncedQuery} />
      ) : !isSearching ? (
        <>
          <StatsCards />
          <CutoffBanner />
        </>
      ) : null}
    </Box>
  )
}
